import Helper from "../../Helper";
import { Activity } from "../../models/Activity";
import { ActivityFilterInfo } from "../Materials/ActivityFilterInfo";

export function getActivitiesForProject(
    team_subdomain: string,
    project_token: string,
    timezone: string,
    filter: ActivityFilterInfo = new ActivityFilterInfo()
): Promise<{ activities: Activity[]; totalCount: number }> {
    const urlString =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/activities";

    const url = new URL(urlString);

    url.search = filter.toUrlSearchParams().toString();

    return Helper.plotFetch(url.toString(), {}, true)
        .then((data) => {
            if (data.ok) {
                return data.json();
            }

            throw new Error("Network error.");
        })
        .then((res) => ({
            activities: res.activities.map((activity: any) => Activity.fromApiObject(activity, timezone)),
            totalCount: res.total_count,
        }))
        .catch(() => ({ activities: [], totalCount: 0 }));
}

export async function uploadScheduleForProject(
    team_subdomain: string,
    project_token: string,
    file: FormData
): Promise<string | null> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/activity_imports";

    const fileEntry = file.get("File") as File;

    if (!fileEntry) {
        throw new Error("No file found in FormData");
    }

    // Calculate SHA-256 hash
    const arrayBuffer = await fileEntry.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest("SHA-256", arrayBuffer);

    // Convert to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");

    const options = {
        method: "post",
        body: file,
        headers: {
            "X-File-Checksum": hashHex,
            "X-Checksum-Algorithm": "SHA-256",
        },
    };
    return Helper.plotFetch(url, options, true)
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
        .then((data) => {
            return data.message;
        })
        .catch(() => {
            return null;
        });
}

export function syncActivitiesForProject(
    team_subdomain: string,
    project_token: string,
    only_update: boolean = false
): Promise<Activity> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        `/projects/${project_token}/activities`;
    const options = {
        method: "put",
        body: JSON.stringify({
            only_update: only_update,
        }),
    };

    return Helper.plotFetch(url, options, true).then((data) => {
        if (data.ok) {
            return data.json();
        }
        throw new Error("Network error.");
    });
}
